export default "__VITE_ASSET__BrIU_l_x__"